import React from 'react';
import { Stack } from '@mui/material';

import { CandidateDetailsAction } from '@constants';
import { GroupFold } from '@hooks';
import { CardGroup } from 'components/common/CardGroup/CardGroup';
import { formatGroupName, GroupedCandidates } from '../grouping';
import { CandidateCard } from './CandidateCard';

interface ICandidateCardListProps {
  groups: GroupedCandidates[];
  positionNameOf: (candidateId: string) => string | undefined;
  onCandidateClick: (id: string) => void;
  onCandidateAction: (id: string, action: CandidateDetailsAction) => void;
  fold: GroupFold;
}

export const CandidateCardList: React.FC<ICandidateCardListProps> = ({
  groups,
  positionNameOf,
  onCandidateClick,
  onCandidateAction,
  fold,
}) => (
  <Stack gap={1} pb={2}>
    {groups.map((group) => {
      const cards = group.candidates.map((candidate) => (
        <CandidateCard
          key={candidate.id}
          candidate={candidate}
          positionName={positionNameOf(candidate.id)}
          onClick={() => onCandidateClick(candidate.id)}
          onAction={onCandidateAction}
        />
      ));

      return group.name ? (
        <CardGroup
          key={group.id}
          name={group.workstream || formatGroupName(group.name)}
          title={group.workstream ? formatGroupName(group.name) : undefined}
          count={group.candidates.length}
          {...fold(group.id)}
        >
          {cards}
        </CardGroup>
      ) : (
        <Stack gap={1} key={group.id}>
          {cards}
        </Stack>
      );
    })}
  </Stack>
);
